import {TableCell, TableSortLabel, Typography} from '@mui/material';
import {SortIcon} from '../task-table/sort-icon';
import type {TableSortDirection} from './table';

export type TableHeaderSortCellProps = {
  /** unique identifier for the column */
  id?: string;
  /** label for the column header */
  label?: string;
  /** whether the column is currently sorted */
  active?: boolean;
  /** direction of sorting */
  direction?: TableSortDirection;
  /** onClick handler for sorting */
  onClick?: (evt: React.MouseEvent) => void;
};

export function TableHeaderSortCell({
  label,
  active = false,
  direction,
  onClick,
}: TableHeaderSortCellProps) {
  return (
    <TableCell>
      <TableSortLabel
        active={active}
        direction={direction}
        IconComponent={() => <SortIcon active={active} direction={direction} />}
        onClick={onClick}
        sx={{
          fontWeight: 500,
          '&.Mui-active': {
            color: 'gray.main',
          },
        }}
      >
        <Typography>{label}</Typography>
      </TableSortLabel>
    </TableCell>
  );
}
